import styled from 'styled-components';

export const WizardContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const WizardBody = styled.div`
  display: flex;
  flex-direction: column;
  width: ${({ $width }) => $width || '640px'};
  max-width: 100%;
  height: ${({ $height }) => $height || '460px'};
`;

export const StepperContainer = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  margin-bottom: 24px;
  padding: 4px 4px 0;
`;

export const StepButton = styled.button`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  flex-shrink: 0;
`;

export const StepCircle = styled.div`
  width: 30px;
  height: 30px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 700;
  flex-shrink: 0;
  transition: all 0.2s ease-in-out;
  box-sizing: border-box;
  border: 2px solid
    ${(props) =>
      props.status === 'done'
        ? '#22c55e'
        : props.status === 'active'
          ? '#3498ff'
          : '#cbd5e1'};
  background: ${(props) =>
    props.status === 'done'
      ? '#22c55e'
      : props.status === 'active'
        ? '#3498ff'
        : '#ffffff'};
  color: ${(props) => (props.status === 'pending' ? '#94a3b8' : '#ffffff')};

  ${StepButton}:hover & {
    border-color: #3498ff;
    ${(props) => props.status === 'pending' && 'color: #3498ff;'}
  }
`;

export const StepLabel = styled.span`
  font-size: 12px;
  font-weight: ${(props) => (props.status === 'active' ? 700 : 500)};
  color: ${(props) => (props.status === 'pending' ? '#94a3b8' : '#334155')};
  white-space: nowrap;

  ${StepButton}:hover & {
    color: #3498ff;
  }
`;

export const StepLine = styled.div`
  width: 64px;
  height: 2px;
  flex-shrink: 0;
  margin: 0 8px;
  margin-top: 15px;
  background: ${(props) => (props.filled ? '#22c55e' : '#e2e8f0')};
  transition: background 0.2s ease-in-out;
`;

export const StepContent = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  animation: fadeIn 0.3s ease-in-out;

  @keyframes fadeIn {
    from { opacity: 0; transform: translateY(5px); }
    to { opacity: 1; transform: translateY(0); }
  }
`;
